import './sun.css'
import React, {FunctionComponent as FC} from 'react'

const Sun:FC = () => {
  return (
	<div className="sun">
		<div className=""></div>
		<div className=""></div>
		<div className=""></div>
		<div className=""></div>
		<div className=""></div>
	</div>
  )
}

export default Sun